
<template>
  <div class="white-container marginTop">
    <p class="mb10 f500">上传视频</p>
    <div class="upload-box">
      <div class="upload-box-left">
        <div v-if="!videoInfo.sourceUrl">
          <el-button type="primary" class="add-btn upload-img-btn upload-video-btn">
            <span>添加视频</span>
            <input accept="video/mp4,video/mov" type="file" class="upload-img-input" @change="handleUploadVideo">
          </el-button>
          <p class="upload-img-tips">支持上传*MP4、*MOV格式视频，大小不超过100MB，尺寸:16.9或4:3</p>
        </div>
        <div v-if="videoInfo.sourceUrl">
          <video id="player-container" ref="customVideo" :src="videoInfo.sourceUrl" class="custom-video" preload="auto" controls playsinline webkit-playsinline style="width: 270px;" />
          <div class="change-img-tips-box">
            <div class="change-img-txt-box">
              <el-button type="primary" class="change-img-btn">重新上传</el-button>
              <input accept="video/mp4,video/mov" type="file" class="upload-img-input" @change="handleUploadVideo">
            </div>
            <p class="upload-img-tips">支持上传*MP4、*MOV格式视频，大小不超过100MB，尺寸:16.9或4:3</p>
          </div>
        </div>
      </div>
      <p class="label-delete" @click="delComponent">删除</p>
    </div>
    <div class="cfg-btn-box">
      <div class="label-box">
        <p>消息模版ID</p>
        <el-input v-model="videoInfo.subscribeId" class="label-input" placeholder="请输入消息模版ID" @change="handleUploadInfo" />
      </div>
      <div class="label-box">
        <el-popover
          placement="bottom-start"
          title="【moduleName】+【_】+【根据UI显示的按钮文案配置】"
          width="440"
          trigger="hover"
          content=""
        >
          <el-button slot="reference" icon="el-icon-info" class="btn-name">btnName</el-button>
        </el-popover>
        <el-input v-model="videoInfo.sensorsData.btnName" class="label-input" placeholder="请输入btnName" @change="handleUploadInfo" />
      </div>
      <div class="label-box">
        <el-popover
          placement="bottom-start"
          title="根据UI显示的模块标题文案配置，两个系统模块拼接成一个UI模块的，同一个UI模块取相同的系统模块名称"
          width="440"
          trigger="hover"
          content=""
        >
          <el-button slot="reference" icon="el-icon-info" class="btn-name">moduleName</el-button>
        </el-popover>
        <el-input v-model="videoInfo.sensorsData.moduleName" class="label-input" placeholder="请输入moduleName" @change="handleUploadInfo" />
      </div>
    </div>
    <div class="marginTop">
      <p>上传视频封面</p>
      <div style="background-color: white;margin-top: 0;padding-top: 10px;padding-left: 0;" class="upload-box">
        <div v-if="!videoInfo.coverImageUrl">
          <el-button class="add-btn upload-img-btn upload-cover-btn" icon="el-icon-plus">
            <input accept="image/jpg,image/png,image/jpeg" type="file" class="upload-img-input" @change="handleUploadImg">
          </el-button>
          <p class="upload-img-tips"> 支持上传*.png、*.jpg <br>  大小不超过2M <br> 尺寸：宽度750px高度不限</p>
        </div>
        <div v-if="videoInfo.coverImageUrl">
          <img class="img-ele" :src="videoInfo.coverImageUrl" alt="">
          <div class="change-img-tips-box">
            <div class="change-img-txt-box">
              <span>更换图片</span>
              <input accept="image/jpg,image/png,image/jpeg" type="file" class="upload-img-input" @change="handleUploadImg">
            </div>
            <p class="upload-img-tips">支持上传*.JPG、PNG*大小不超过5M，尺寸：宽度750高度不限制</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'UploadVideo',
  props: {
    videoInfo: {
      type: Object,
      default: () => (
        { sourceUrl: '', jumpLink: '', sensorsData: { btnName: '', moduleName: '' }, subscribeId: '', cloudVideoId: null, coverImageUrl: '' }
      ),
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  created() {
  },
  methods: {
    delComponent() {
      this.$emit('del', this.index);
    },
    /* input 上传图片  */
    async handleUploadImg(e) {
      const file = e.target.files[0];
      const res = await this.checkImgInfo(file);
      if (res) {
        this.$Api.uploadFile.uploadImage(file, 'loyaltyCampaign/').then(data => {
          this.uploadLoading = false;
          this.videoInfo.coverImageUrl = data;
          this.handleUploadInfo();
          this.$message.success('图片上传成功');
          /* 删除input的值 */
          e.target.value = '';
        });
      } else {
        e.target.value = '';
      }
    },
    /* input 上传视频 */
    async handleUploadVideo(e) {
      const file = e.target.files[0];
      const res = await this.checkVideoInfo(file);
      if (res) {
        this.$Api.uploadFile.putCloudDemandUpload({ mediaFile: file, hideLoading: false }).then(data => {
          this.uploadLoading = false;
          // console.log('data', data);
          this.videoInfo.sourceUrl = data.mediaUrl;
          // this.videoInfo.sourceUrl = 'http://1257321318.vod2.myqcloud.com/ce6733a3vodcq1257321318/287980281397757900385209008/foxcfPBQApUA.mp4';
          this.videoInfo.cloudVideoId = data.fileId;
          // this.videoInfo.cloudVideoId = '1397757900385209008';
          this.handleUploadInfo();
          this.$message.success('视频上传成功');
          e.target.value = '';
        });
      } else {
        e.target.value = '';
      }
    },
    async checkImgInfo(file) {
      try {
        const ALLOWED_TYPES = ['image/jpg', 'image/jpeg', 'image/png'];
        const MAX_SIZE = 2 * 1024 * 1024; // 5MB
        const REQUIRED_WIDTH = 750;
        if (!ALLOWED_TYPES.includes(file.type)) {
          this.$message.error('请上传 JPG 或 PNG 格式的图片');
          return false;
        }
        if (file.size > MAX_SIZE) {
          this.$message.error(`图片大小不能超过 ${MAX_SIZE / 1024 / 1024}M`);
          return false;
        }
        const dimensions = await this.getImageDimensions(file);
        if (dimensions.width !== REQUIRED_WIDTH) {
          this.$message.error(`图片宽度必须为 ${REQUIRED_WIDTH}px`);
          return false;
        }
        return true;
      } catch (error) {
        this.$message.error('图片验证失败：' + error.message);
        return false;
      }
    },
    getImageDimensions(file) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          URL.revokeObjectURL(img.src);
          resolve({ width: img.width, height: img.height });
        };
        img.onerror = () => {
          URL.revokeObjectURL(img.src);
          reject(new Error('图片加载失败'));
        };
      });
    },
    getVideoDimensions(file) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file);
        video.onloadedmetadata = () => {
          URL.revokeObjectURL(video.src);
          resolve({ width: video.videoWidth, height: video.videoHeight });
        };
        video.onerror = () => {
          URL.revokeObjectURL(video.src);
          reject(new Error('视频加载失败'));
        };
      });
    },
    async checkVideoInfo(file) {
      const MAX_SIZE = 100 * 1024 * 1024; // 100MB
      const ALLOWED_TYPES = ['video/mp4', 'video/mov'];
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.$message.error('请上传 MP4 或 MOV 格式的视频');
        return false;
      }
      if (file.size > MAX_SIZE) {
        this.$message.error(`视频大小不能超过 ${MAX_SIZE / 1024 / 1024}M`);
        return false;
      }
      /* 视频 尺寸 16：9 或 4：3 */
      const dimensions = await this.getVideoDimensions(file);
      console.log('dimensions', dimensions);
      if (dimensions.width / dimensions.height !== 16 / 9 && dimensions.width / dimensions.height !== 4 / 3) {
        this.$message.error('视频尺寸必须为 16:9 或 4:3');
        return false;
      }
      return true;
    },
    handleUploadInfo() {
      console.log('handleUploadInfo');
      this.videoInfo.jumpLink = '';
      this.$emit('uploadVideo', { videoInfo: this.videoInfo, index: this.index });
    },
  },
};
</script>
<style lang="less" scoped>
  /deep/ .label-input .el-input__inner{
    height: 34px;
  }
  .f500{
    font-weight: 500;
  }
  .mb10{
    margin-bottom: 10px;
  }
  .marginTop {
    margin-top: 30px;
  }
  .upload-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 222px;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 30px 44px;
    background: #f7f7f7;
    .upload-box-left{
      display: flex;
      align-items: center;
      gap: 60px;
    }
    .upload-img-tips{
      font-size: 12px;
      color: #bbb;
      margin-top: 5px;
      line-height: 1.2;
    }

    .label-delete{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin-right: 100px;
    }
    .change-img{
      font-size: 14px;
      color: #0085D0;
      cursor: pointer;
      margin: 10px 0;
    }
    .img-ele{
      width: 210px;
      height: 150px;
      border-radius: 4px;
      object-fit: cover;
    }
    .change-img-tips-box{
      display: flex;
      align-items: center;
      margin-top: 6px;
      .change-img-txt-box{
        position: relative;
        color: #0085D0;
        cursor: pointer;
        margin-right: 15px;
        .upload-img-input{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
        }
        .change-img-btn{
          width: 110px;
          height: 38px;
        }
      }
    }
  }
  .upload-img-btn{
    position: relative;
    width: 210px;
    height: 150px;
    font-size: 30px;
    color: #bbb;
    .upload-img-input{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
  .upload-video-btn{
    width: 110px;
    height: 38px;
    font-size: 16px;
    border: none !important;
    color: #fff;
  }
  .add-btn{
    width: 150px;
    height: 34px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .label-box{
    display: flex;
    align-items: center;
    min-width: 432px;
    font-size: 14px;
    .label-input{
      width: 360px;
      margin-left: 4px;
    }
    .btn-name{
      border: none;
      padding: 0;
    }
    .btn-name:hover{
      background: none;
    }
  }
  .cfg-btn-box{
    display: flex;
    align-items: center;
    gap:30px;
    flex-wrap: wrap;
  }
  .upload-cover-btn{
    width: 150px;
    height: 150px;
    border: 1px dashed #9B9B9B;
    border-radius: 4px;
    background-color: #f7f7f7;
  }
  .custom-video{
    width: 210px;
    height: 202px;
    border-radius: 4px;
    object-fit: cover;
  }
</style>
